import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import { officesApi } from '../app/offices.js'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {selectUsers}  from '../app/users.js'
import {addOfficeInProject, projectsApi, addUserInProject}  from '../app/projects.js'
import ClearIcon from '@mui/icons-material/Clear';
import { Accordion, AccordionDetails, AccordionSummary, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import { selectCanAccess, selectCanDo } from '../app/auth.js';
import { getInspectionLinkType } from '../app/layers.js';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import { Link as RouterLink } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';

const OUTPUTFIELDS = {
  offices: `id,name,userIds, projectId, missionIds, roles`,
  users: `id,name,email`
}

const OfficeCard = ({ missionList, projectId, office, officeList, setOfficeList, usersList}) => {

  // get data from office
  const [officeUsers, setOfficeUsers] = useState(office.userIds)
  const [officeRoles, setOfficeRoles] = useState(office.roles)
  const [officeMissions, setOfficeMissions] = useState(office.missionIds)
  const users = useSelector(selectUsers) // get users list
  const [openConfirm, setOpenConfirm] = useState(false); // handle confirmation modal for delete

  useEffect(() => {
    // hanldes non init fields in office
    if (!officeUsers)
      setOfficeUsers([])
    if (!officeRoles)
      setOfficeRoles([])
      if(!officeMissions)
      setOfficeMissions([])
  }, [])

  const removeOfficeFromProject = (id) => {
    officesApi.delete({id, projectId}, (result) => {
      if(result){
        setOfficeList(officeList.filter((o) => o.id != id))
      }
    })
  }

  // hanfdles Missions in offices
  const handleAddMissionToOffice = (mission) => {
    officesApi.addInProjectOffice({
      id: office.id,
      missionIds: [mission],
    }, OUTPUTFIELDS.offices, (result) => {
      if (result.addInProjectOffice) {
        setOfficeMissions(() => [...new Set([...officeMissions, mission])])
      }
    })
  }
  const removeMissionToOffice = (mission) => {
    officesApi.removeInProjectOffice({
      id: office.id,
      missionIds: [mission],
    }, OUTPUTFIELDS.offices, (result) => {
      if (result) {
        setOfficeMissions(officeMissions.filter((m) => m != mission))
      }
    })
  }

  // handles User in offices
  const handleAddUserInProjectOffice = (user) => {
    officesApi.addInProjectOffice({
      id: office.id,
      userIds: [user],
    }, OUTPUTFIELDS.offices, (result) => {
      if (result) {
        setOfficeUsers(() => [...new Set([...officeUsers, user])]);
      }
    })
  }
  const handleRemoveUserFromOfficeInProject = (user) => {
    officesApi.removeInProjectOffice({
      id: office.id,
      userIds: [user],
    }, OUTPUTFIELDS.offices, (result) => {
      if (result.removeInProjectOffice) {
        setOfficeUsers([...new Set(officeUsers.filter((u) => u != user))])
      }
    })
  }

  // handles Roles in offices
  const handleAddRoleInOffice = (role) => {
    officesApi.addInProjectOffice({
      id: office.id,
      roles: [role],
    }, OUTPUTFIELDS.offices, (result) => {
      console.log(result)
      if (result) {
        setOfficeRoles([...new Set([...officeRoles, role])]);
      }
    })
    
  }
  const handleRemoveRoleFromOffice = (role) => {
    officesApi.removeInProjectOffice({
      id: office.id,
      roles: [role],
    }, OUTPUTFIELDS.offices, (result) => {
      if (result) {
        console.log(result)
        setOfficeRoles(officeRoles.filter((r) => r != role))
      }
    })
  }

  // handless deletion and delete confirmation modal
  const handleDeleteClick = (event) => {
    event.stopPropagation();
    setOpenConfirm(true);
  };
  const handleConfirmDelete = () => {
    removeOfficeFromProject(office.id);
    setOpenConfirm(false);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  return (
    <Grid item xs={12}>
      <Paper>
        <Accordion sx={{ boxShadow: '0 2px 2px -2px white', mb: 1 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h6">
              {office.name}
            </Typography>
            {/* Top-right button */}
            <Box sx={{ position: 'absolute', right: 50, top: 8, zIndex: 1 }}>
              <Button size="small" onClick={handleDeleteClick}>
                <ClearIcon />
              </Button>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {/* Mission grid */}
              <Grid item xs={4}>
                <b>Missions</b>
                <FormControl fullWidth>
                  <Select
                    onChange={(e) => handleAddMissionToOffice(e.target.value)}
                    defaultValue=""
                  >
                    <MenuItem value={0} disabled default>Add a mission</MenuItem>
                    {missionList && 
                      missionList.map((m) => (
                        <MenuItem key={m.id} value={m.id}>
                          {m.name}
                        </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  { officeMissions &&
                    officeMissions.map((m, index) => {
                      // m is the mission ID, not an object with .id property
                      // Use the mission ID directly, or index as fallback for unique key
                      const missionId = m != null ? String(m) : `undefined_${index}`;
                      return (
                        <li key={`office_mission_${missionId}_${index}`} style={{ listStyle: "none" }}>
                          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ width: '100%' }}>
                            <Typography variant="body2">{missionList.filter((mission) => mission.id == m)[0]?.name}</Typography>
                            <Button onClick={() => removeMissionToOffice(m)} size="small" sx={{ minWidth: 'auto', padding: 0.5 }}>
                              <ClearIcon fontSize="small" />
                            </Button>
                          </Stack>
                        </li>
                      );
                    }) 

                  }
                </ul>
              </Grid>

              {/* Roles grid */}
              <Grid item xs={4}>
                <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  <li><b>Role</b></li>
                  <li>
                    <FormControl fullWidth>
                        <Select
                          onChange={(e) => handleAddRoleInOffice(e.target.value)}
                          defaultValue=""
                        >
                          <MenuItem value={0} disabled default>Add a Role</MenuItem>
                          {
                            ["reader", "contributor", "production"].map((role) => (
                              <MenuItem key={role} value={role}>
                                {role}
                              </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                  </li>
                  {officeRoles &&
                    officeRoles.map((role) => {
                      return <li key={role}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ width: '100%' }}>
                          <Typography variant="body2">{role}</Typography>
                          <Button onClick={() => handleRemoveRoleFromOffice(role)} size="small" sx={{ minWidth: 'auto', padding: 0.5 }}>
                            <ClearIcon fontSize="small" />
                          </Button>
                        </Stack>
                      </li>
                    })
                  }
                </ul>
              </Grid>

              {/* Users grid */}
              <Grid item xs={4}>
                <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  <li><b>Users</b></li>
                  <li>
                    <FormControl fullWidth>
                      <Select
                        onChange={(e) => handleAddUserInProjectOffice(e.target.value)}
                        defaultValue=""
                      >
                        <MenuItem value={0} disabled default>Add a User</MenuItem>
                        {users.length > 0 && usersList.length > 0 &&
                          usersList.map((u) => {
                            const user = users.filter((usr) => usr.id === u)[0]
                            return <MenuItem key={user.id} value={user.id}>
                              {user.email}
                            </MenuItem>
                          })}
                      </Select>
                    </FormControl>
                  </li>
                  {officeUsers &&
                    officeUsers.map((user) => (
                      <li key={user}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ width: '100%' }}>
                          <Typography variant="body2">{users && users.length > 0 && users.find((u) => u.id === user).email}</Typography>
                          <Button onClick={() => handleRemoveUserFromOfficeInProject(user)} size="small" sx={{ minWidth: 'auto', padding: 0.5 }}>
                            <ClearIcon fontSize="small" />
                          </Button>
                        </Stack>
                      </li>
                    ))
                  }
                </ul>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        
        {/* Confirmation Dialog */}
        <Dialog
          open={openConfirm}
          onClose={handleCloseConfirm}
          aria-labelledby="confirm-dialog-title"
          aria-describedby="confirm-dialog-description"
        >
          <DialogTitle id="confirm-dialog-title">Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-dialog-description">
              Are you sure you want to delete this office?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirm} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="secondary" variant="contained">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Grid>
  );
}

function ProjectCard({project:{id, name, projectNumber, missions, userIds, adminIds, ownerIds, offices}}){
  const dispatch = useDispatch()
  const users = useSelector(selectUsers)
  const canAccessSelector = useSelector(selectCanAccess);
  const canDoSelector = useSelector(selectCanDo);
  const navigate = useNavigate();

  // Cache canAccess results to avoid expensive recalculations
  // isUserAllowed is called multiple times (once per mission), so we cache results
  const canAccessCache = useRef(new Map());
  
  const canAccess = useCallback((pageName, otherInfos = {}) => {
    const cacheKey = `${pageName}_${otherInfos.projectId}_${otherInfos.missionId || ''}`;
    if (canAccessCache.current.has(cacheKey)) {
      return canAccessCache.current.get(cacheKey);
    }
    const result = canAccessSelector(pageName, otherInfos);
    canAccessCache.current.set(cacheKey, result);
    return result;
  }, [canAccessSelector]);
  
  // Clear cache when component unmounts or key dependencies change
  useEffect(() => {
    return () => {
      canAccessCache.current.clear();
    };
  }, [id]);

  const [newOfficeName, setNewOfficeName] = useState('');
  const [userToAdd, setUserToAdd] = useState('')
  const [officeList, setOfficeList] = useState(offices)
  const [missionList, setMissions] = useState(missions)
  const [usersList, setUserList] = useState(userIds);

  function handleCreateOffice(name){
    officesApi.create({name,projectId: id}, OUTPUTFIELDS.offices, (result) => {
      console.log(result)
      dispatch(addOfficeInProject({id: id, office:result}))
      setOfficeList([...new Set([...officeList, result])])
    })
  }

  function handleAddUserInProject(){
    if(userToAdd !== null){
      projectsApi.addUserInProject({userId: userToAdd, projectId: id}, OUTPUTFIELDS.users, (result) => {
        dispatch(addUserInProject({id: id, user:userToAdd}))
        setUserList([...new Set([...usersList, userToAdd])])
        setUserToAdd(null);
      })
    }
  }

  function handleRemoveUserFromProject(userId){
    projectsApi.removeUserInProject({userId, projectId: id}, OUTPUTFIELDS.users, (result) => {
      if (result.removeUserInProject) {
        console.log(result)
        setUserList([...new Set(usersList.filter((u) => u != userId))])
      }
    })      
  }

  // OPTIMIZATION: Memoize user email lookup to avoid repeated filters
  const usersMap = useMemo(() => {
    const map = new Map();
    users.forEach((usr) => {
      map.set(usr.id.toString(), usr.email);
    });
    return map;
  }, [users]);

  // Function that gives the user email for a given user id
  const user_email = (user_id) => {
    return usersMap.get(user_id.toString()) || "unknown";
  };

  // Memoize Set of users in offices for fast lookup
  const usersInOfficesSet = useMemo(() => {
    const set = new Set();
    offices.forEach((o) => {
      if (o.userIds) {
        o.userIds.forEach((userId) => set.add(userId));
      }
    });
    return set;
  }, [offices]);

  // Memoize table rows calculation to avoid expensive recalculations
  // Use cached canAccess to avoid repeated expensive isUserAllowed calls
  const tableRows = useMemo(() => {
    const allRows = [];
    missionList.forEach((m) => {
      //  user has to be allowed by office to see the mission
      // Use cached canAccess to avoid repeated expensive calls
      const hasAccess = canAccess("accessMission", {projectId: id, missionId: m.id});
      if (hasAccess) {
        // init the rows that will be in the table
        if (m.inspections) {
          m.inspections.forEach((i) => {
            if (i.url) {
              allRows.push({
                id: i.id,
                mission: m.name,
                name: i.name,
                type: 'external',
                link: i.url,
                external: true,
              })
            } else {
              i.views.forEach((v) => {
                const inspectionType = getInspectionLinkType(i);
                const link = inspectionType === 'photo'
                  ? `/photo-viewer?inspectionId=${i.id}&viewId=${v.id}`
                  : `/ortho?inspectionId=${i.id}&viewId=${v.id}`;
                allRows.push({
                  id: i.id,
                  mission: m.name,
                  name: i.name,
                  type: inspectionType,
                  link
                })
              })
            }
          })
        }
        if (m.potreeLayers) {
          m.potreeLayers.forEach((pt) => {
            allRows.push({
              id: pt.id,
              mission: m.name,
              name: pt.name,
              type: "3D",
              link: `/3D?id=${pt.id}`
            })
          })
        }
      }
    });
    return allRows;
  }, [missionList, canAccess, id]);

  return <Paper sx={{p: 2, display: 'flex', flexDirection: 'column' }}>
    <Stack spacing={2}  sx={{ flexGrow: 1 }}>
      <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      className={id}
      >
        <Typography variant="h3" color="primary">
          {name}
        </Typography>
        { canAccess("ProjectEditPage", {projectId: id}) &&
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={() => navigate(`/projects/edit/${id}`)}
          >
            Edit
          </Button>
        }
      </Box>
      {/* Admin handler for the project
        Allow the users in adminIds of the project to handle:
          - offices in the project
          - roles and users in the project offices
      */}
      { canDoSelector("administrate") &&
        <Accordion sx={{ boxShadow: '0 2px 2px -2px white'}}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h5" color="primary">
              Admin Zone
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} sx={{ mb: 4 }}>
              <Grid item xs={12}>
                <Typography component="h1" xs={12} variant="h6" gutterBottom>General information</Typography>
              </Grid>
              <Grid item xs={12}>
                <Stack direction="column" spacing={0} sx={{ pl: 2 }}>
                  <Typography>Project ID: {id}</Typography>
                  <Typography>Numéro d'affaire: {projectNumber === null ? "none" : projectNumber}</Typography>
                  <Typography>Project owners: {ownerIds.length === 0 ? "none" : ownerIds.map((uid) => user_email(uid)).join(", ")}</Typography>
                  <Typography>Project admins: {adminIds.length === 0 ? "none" : adminIds.map((uid) => user_email(uid)).join(", ")}</Typography>
                </Stack>
              </Grid>
            </Grid>


            <Grid container spacing={2}>
              {/* Users grid */}
              <Grid item xs={5}>
                <Typography component="h1" variant="h6" gutterBottom>Users</Typography>
                <Stack direction="row" spacing={2}>
                  <FormControl fullWidth>
                    <Select
                      id="demo-simple-select"
                      value={userToAdd || ''}
                      onChange={(e) => setUserToAdd(e.target.value || '')}
                    >
                      <MenuItem value="">Pick User</MenuItem>
                      {users && users.length > 0 && users.map((u) => (
                        <MenuItem key={u.id} value={u.id}>
                          {u.email}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Button variant="outlined" onClick={handleAddUserInProject}>
                    Add
                  </Button>
                </Stack>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {usersList.map((m) => (
                    <li key={m}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ width: '100%' }}>
                        <Typography sx={{ color: usersInOfficesSet.has(m) ? "white" : "orange" }}>
                          {users && users.length > 0 && users.filter((u) => u.id === m)[0].email}
                        </Typography>
                        <Button variant="contained" onClick={() => handleRemoveUserFromProject(m)}>
                          <ClearIcon />
                        </Button>
                      </Stack>
                    </li>
                  ))}
                </ul>
              </Grid>
              <Grid item xs={2}>
              </Grid>
              
              {/* Missions grid */}
              <Grid item xs={5}>
                <Typography component="h1" variant="h6" gutterBottom>Missions</Typography>
                <ul>
                  {missionList.map((m) => (
                    <li key={m.id}>{m.name}</li>
                  ))}
                </ul>
              </Grid>
            </Grid>
            
            {/* Offices grid */}
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Typography component="h1" variant="h6" gutterBottom>
                  Offices
                </Typography>
                <Stack direction="row" spacing={2}>
                  <FormControl fullWidth>
                    <TextField
                    label="Office Name" 
                    variant="outlined" 
                    id="name" 
                    value={newOfficeName}
                    onChange={(event) => {
                      setNewOfficeName(event.target.value);
                    }}
                    />
                  </FormControl>
                  <Button sx={{margin: 3}} variant="contained" onClick={() => handleCreateOffice(newOfficeName)}>Create</Button>
                </Stack>
              
                <Stack spacing="2">
                  {officeList.map((o) => <OfficeCard key={o.id} missionList={missionList} projectId={id} office={o} officeList={officeList} setOfficeList={setOfficeList} usersList={usersList} />)}
                </Stack>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      }
      {/* display missions list accessible to the user */}
      {missionList.length > 0 && tableRows.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Mission</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((r, rowIndex) => (
              <TableRow key={`${r.id}_${rowIndex}`}>
                <TableCell>{r.mission}</TableCell>
                <TableCell>{r.name}</TableCell>
                <TableCell>{r.type}</TableCell>
                <TableCell>
                  {r.external ? (
                    <Link href={r.link} target="_blank" rel="noopener noreferrer">
                      See
                    </Link>
                  ) : (
                    <Link to={r.link} component={RouterLink}>
                      See
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Stack>  
  </Paper>
}

export default ProjectCard
